import React from 'react';
import
{
    navigate
}
from './Router';

export default function SpotTheFloof()
{
    return ( <div id = "spot-the-floof-root"
        style = {
            {
                position: 'fixed',
                inset: 0,
                zIndex: 10000,
                background: '#000',
                pointerEvents: 'auto'
            }
        } >
        <div style = {
            {
                position: 'absolute',
                left: '50%',
                top: '36%',
                transform: 'translate(-50%, -50%)',
                color: '#fff',
                fontSize: '3rem',
                fontWeight: 700,
                letterSpacing: '0.04em',
                lineHeight: 1,
                textAlign: 'center',
            }
        } >
        Spot the Floof!
        </div> <div style = {
            {
                position: 'absolute',
                left: '50%',
                bottom: '14vh',
                transform: 'translateX(-50%)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 10,
            }
        } >
        <button type = "button"
        style = {
            {
                padding: 0,
                border: 0,
                background: 'transparent',
                color: '#fff',
                fontSize: '2.25rem',
                fontWeight: 700,
                letterSpacing: '0.08em',
                cursor: 'pointer',
                lineHeight: 1,
            }
        } >
        PLAY </button> <button type = "button"
        onClick = {
            () => navigate('/main')
        }
        style = {
            {
                padding: 0,
                border: 0,
                background: 'transparent',
                color: '#6e1111',
                fontSize: '1.2rem',
                fontWeight: 700,
                letterSpacing: '0.08em',
                cursor: 'pointer',
                lineHeight: 1,
            }
        } >
        MAIN MENU </button> </div> </div>
    );
}
